/**
 * React Query key factory for auth-related queries.
 * Follows the Forge pattern: centralized, composable, type-safe.
 */

export const authKeys = {
  all: ['auth'] as const,
  status: () => [...authKeys.all, 'status'] as const,
  me: () => [...authKeys.all, 'me'] as const,
  /**
   * OAuth provider availability probe (GET /api/auth/oauth/providers).
   * Distinct sub-key so it caches independently of the session-status
   * query — provider config rarely changes, the session does.
   */
  oauthProviders: () => [...authKeys.all, 'oauthProviders'] as const,
}
